import { IConnectContact } from '@epicuro-next/data/connect';
import { ConnectionStatus } from '@epicuro-next/models/users';
import { Dictionary } from '@ngrx/entity';

const accountName = 'Multibrand DK Test Account';

export const mockContacts = [
  {
    displayName: 'Markus Zavander 0',
    email: 'mz@neocles.io0',
    userId: 'mz@neocles.io0',
    imageLink: '',
    connectionStatus: 'NotAvailable',
    accounts: [],
  },
  {
    displayName: 'Rasmus Merkant 1',
    email: 'rm@neocles.io1',
    userId: 'rm@neocles.io1',
    imageLink: '',
    connectionStatus: 'Available',
    accounts: [],
  },
  {
    displayName: 'Mesiah Karkovic 2',
    email: 'mk@neocles.io2',
    userId: 'mk@neocles.io2',
    imageLink: '',
    connectionStatus: 'NotAvailable',
    accounts: [],
  },
  {
    displayName: 'Markus Zavander 3',
    email: 'mz@neocles.io3',
    userId: 'mz@neocles.io3',
    imageLink: '',
    connectionStatus: 'NotAvailable',
    accounts: [
      {
        externalId: '1001',
        name: accountName,
      },
    ],
  },
  {
    displayName: 'Mesiah Karkovic 4',
    email: 'mk@neocles.io4',
    userId: 'mk@neocles.io4',
    imageLink: '',
    connectionStatus: 'Available',
    accounts: [
      {
        externalId: '1001',
        name: accountName,
      },
    ],
  },
  {
    displayName: 'Mesiah Karkovic 5',
    email: 'mk@neocles.io5',
    userId: 'mk@neocles.io5',
    imageLink: '',
    connectionStatus: 'Available',
    accounts: [
      {
        externalId: '1001',
        name: accountName,
      },
    ],
  },
  {
    displayName: 'Rasmus Merkant 6',
    email: 'rm@neocles.io6',
    userId: 'rm@neocles.io6',
    imageLink: '',
    connectionStatus: 'NotAvailable',
    accounts: [],
  },
  {
    displayName: 'Mesiah Karkovic 7',
    email: 'mk@neocles.io7',
    userId: 'mk@neocles.io7',
    imageLink: '',
    connectionStatus: 'Available',
    accounts: [
      {
        externalId: '1001',
        name: accountName,
      },
    ],
  },

  {
    displayName: 'Markus Zavander 8',
    email: 'mz@neocles.io8',
    userId: 'mz@neocles.io8',
    imageLink: '',
    connectionStatus: 'Available',
    accounts: [
      {
        externalId: '9999',
        name: accountName,
      },
    ],
  },
  {
    displayName: 'Rasmus Merkant 9',
    email: 'rm@neocles.io9',
    userId: 'rm@neocles.io9',
    imageLink: '',
    connectionStatus: 'OnCall',
    accounts: [
      {
        externalId: '1001',
        name: accountName,
      },
      {
        externalId: '1003',
        id: 'a0792526-6421-4406-8500-760675c4250d',
        name: 'Puma DK Test account',
      },
    ],
  },
] as IConnectContact[];

export const mockContactsEntities = mockContacts.reduce(
  (result: Dictionary<IConnectContact>, item: IConnectContact) => {
    result[item.userId] = item;
    return result;
  },
  {},
);

export const mockContactsIds = mockContacts.map((item) => item.userId);

export const mockConnectToken =
  'LpEFFd2voUlkpwMZhWnj1KEQUnKDGPPWsabDMXwrnwrnKC2rHyBnZi1v5ibob';

export const mockTwilioToken =
  'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImN0eSI6InR3aWxpby1mcGE7dj0xIn0.eyJqdGkiOiJTSzg4ZjRjZTM0YjViMDQ4OTk2OGRkMjIxMjIzMmYzYjgyLTE2MDQzMjUxNTgiLCJpc3MiOiJTSzg4ZjRjZTM0YjViMDQ4OTk2OGRkMjIxMjIzMmYzYjgyIiwic3ViIjoiQUM0OTVlZGE5N2FhOWZhZjcwYzA5MjBmMjVhZmFjODM2NiIsImV4cCI6MTYwNDMyODc1OCwiZ3JhbnRzIjp7ImlkZW50aXR5IjoiU0s4OGY0Y2UzNGI1YjA0ODk5NjhkZDIyMTIyMzJmM2I4MiIsInZpZGVvIjp7InJvb20iOiJuZW9jbGVzLXB1bHNlIn19fQ.olXJNXCIn8GPPRx8j0ZDAoBFRRePXFrntC_6-d2KH84';

export const mockTwilioRoom = 'connect-pulse';
export const mockTwilioRoomResult = {
  sid: 'RM87c6986857412a633cf5abefb0b1b7f8',
  name: 'neocles-pulse',
  participantCount: 0,
  maxParticipants: 50,
};

const mockContact = mockContacts[0];

export const connectMock = {
  contacts: {
    entities: mockContactsEntities,
    ids: mockContactsIds,
    selectedContactId: mockContact.userId,
  },
  data: {
    userConnectionStatus: ConnectionStatus.ONCALL,
    videoLoading: true,
    incomingCall: {
      contact: mockContact,
      roomName: mockTwilioRoom,
    },
    currentContact: mockContact,
    connectToken: mockConnectToken,
    twilioToken: mockTwilioToken,
    twilioRoom: mockTwilioRoomResult,
    notificationPermission: 'default',
  },
};
